// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"99b19f2a","453":"7d0a9de1","983":"13a083d8"}[chunkId] + ".chunk.js";
};